import * as React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { replace } from 'react-router-redux'
import { condition } from '../../common/util'
import Button from '../components/button'
import { withSubmission } from '../modules/submission'
import { withQuoteSupport } from '../modules/quote-support'
import { withFields } from '../../common/modules/fields'
import { withNavigation } from '../modules/navigation'
import { withProductData } from '../../common/modules/product-data';
import './button.css'
import { withConfig } from '../modules/config'

class Container extends React.Component< { show?:boolean}, any>{
    
    renderChildren() {
        return this.props.children 
    }
    
    render(){
        const show = this.props.show;
        if(show == null || show){
            return (
                <div className="col-12 mt-4">
                    {this.renderChildren()}
                </div>
            )
        }else{
            return null;
        }
    }
}

class Generic extends React.Component<{ onClick:()=>void }, any>{

    onClick(e){
        this.props.onClick();
    }

    render(){
        return (
            <button className="btn btn-lg btn-primary col-sm-auto mb-2" onClick={ this.onClick.bind(this) }>{ this.props.children }</button>
        )
    }
}

@withNavigation
class Back extends React.Component<{ route:string, actions?:any }, any>{

    onClick(e){
        this.props.actions.navigation.changeRoute( this.props.route )
    }

    render(){
        return (
            <button className="btn btn-lg btn-primary col-sm-auto mb-2" onClick={ this.onClick.bind(this) }>Back</button>
        )
    }
}

@withSubmission
@withQuoteSupport
@withNavigation
@withProductData
class PayOffline extends React.Component<any, any>{

    proceed(){
        this.props.actions.navigation.changeRoute("/payment-offline")
    }

    onClick(e){
        const endpoint = this.props.quoteSupport.endpoints.payOffline;
        const data = {
            type: "TaxInvoice"
        }

        this.props.actions.submission.post(endpoint, this.proceed.bind(this), data);
    }

    render(){
        const productData = this.props.productData
        const button = <button className="btn btn-primary btn-payment btn-lg mb-2 mr-2" onClick={ this.onClick.bind(this) }><i className="fa fa-keyboard-o" aria-hidden="true"></i><span className="text-left">Pay offline<br />(EFT or BPay)</span></button>
        return (
            condition(productData.paymentOptions.includes('OFFLINE'), button)
            )
    }
}

@withNavigation
@withProductData
class PayMastercard extends React.Component<any, any>{

    onClick(e){
        this.props.actions.navigation.changeRoute("/payment-by-card")
    }

    render(){
        const productData = this.props.productData
        const button = <button className="btn btn-primary btn-payment btn-lg mb-2 mr-2" onClick={ this.onClick.bind(this) } ><i className="fa fa-credit-card" aria-hidden="true"></i><span className="text-left">Pay by Visa<br />or Mastercard</span></button>
        return (
            condition(productData.paymentOptions.includes('BRAINTREE'), button)
            )
    }
}


@withSubmission
@withQuoteSupport
@withNavigation
@withProductData
@withFields
@withConfig
class PayInstalments extends React.Component<any, any>{

    onClick(e){
        this.props.navigation.warnOnClose = false;

        const token = this.props.fields.token;
        const productData = this.props.productData
        const useMPF = productData.paymentOptions.includes('MPF')
        
        if(useMPF){
            // Use the MPF instalments module
            window.location.href = this.props.quoteSupport.endpoints.payInstalmentsMPF + "?token=" + token
        }else{
            // Use the in-house instalments module
            const returnPath = window.location.protocol + '//' + window.location.host + window.location.pathname;
            const params = {
                    externalId: token,
                    title: this.props.config.projectTitle + ' Insurance Quote',
                    success: returnPath + '#payment-result?successful=true&token=' + token,
                    cancel: returnPath + '#restore?step=payment&token=' + token,
                    error: returnPath + '#restore?step=payment-result&successful=false&token=' + token,
            }

            const paramStrings = Object.keys(params).map(key =>  key + "=" + encodeURIComponent(params[key]))
            const instalmentsURL = this.props.quoteSupport.endpoints.payInstalments + '?' + paramStrings.join("&");
            window.open(instalmentsURL, "_self");
        }
    }


    render(){
        const productData = this.props.productData
        const fields = this.props.fields
        const button = <button className="btn btn-primary btn-payment btn-lg mb-2 mr-2" onClick={ this.onClick.bind(this) } ><i className="fa fa-calendar" aria-hidden="true"></i><span className="text-left">Pay by<br />instalments</span></button>
        
        let shouldRender = productData.paymentOptions.includes('MPF') || productData.paymentOptions.includes('INHOUSE_INSTALMENTS')
        if(fields.referenceCode) shouldRender = false;

        return (
            condition(shouldRender && fields.totalPayable >= productData.mpfPremiumMin && fields.totalPayable <= productData.mpfPremiumMax, button)
        )
    }
}


class PaymentButtons extends Container {
    renderChildren(){
        return (
            <Button.Container>
                <PayMastercard />
                <PayOffline />
                <PayInstalments />
            </Button.Container>
        )
    }
}

class Save extends React.Component<{ onClick:()=>void }, any>{

    onClick(){
        this.props.onClick()
    }

    render(){
        return (
            <button className="btn btn-lg btn-primary col-sm-auto mb-2 ml-0 ml-sm-2" onClick={ this.onClick.bind(this) } >Save and exit</button>
        )
    }
}
                    
class BuyNow extends React.Component<{ onClick:()=>void }, any>{

    render(){
        return (
            <button className="btn btn-lg btn-primary pull-right col-12 col-sm-auto mb-2" onClick={ e => this.props.onClick() }>Buy Now</button>
        )
    }
}

class Continue extends React.Component<{ onClick:()=>void }, any>{

    static propTypes = {
        onClick: PropTypes.func
    }

    render(){
        return (
            <button className="btn btn-lg btn-primary pull-right col-12 col-sm-auto mb-2" onClick={ e => this.props.onClick() }>{ this.props.children ? this.props.children : "Continue" }</button>
        )
    }
}

export default {
    Generic,
    Save,
    Back,
    Continue,
    Container,
    PaymentButtons,
    BuyNow
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/button.tsx